import { useState, useCallback } from "react";
import { submitHousehold } from "../api/taxApi";
import type { HouseholdInput, HouseholdReport } from "../types";

export function useHouseholdReport(): {
  report: HouseholdReport | null;
  loading: boolean;
  error: Error | null;
  submit: (payload: HouseholdInput) => Promise<{ success: boolean; error?: string }>;
} {
  const [report, setReport] = useState<HouseholdReport | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const submit = useCallback(async (payload: HouseholdInput): Promise<{ success: boolean; error?: string }> => {
    setLoading(true);
    setError(null);
    try {
      const data = await submitHousehold(payload);
      setReport(data);
      return { success: true };
    } catch (err) {
      const e = err as Error;
      setError(e);
      return { success: false, error: e.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return { report, loading, error, submit };
}